
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';

export const metadata = {
  toc: true,
  layout: 'guide',
  source: 'error',
  description: 'Guide to understanding and troubleshooting errors specific to the Income product.',
  title: 'Income'
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Header = makeShortcode("Header");
const ErrorReference = makeShortcode("ErrorReference");
const Checkbox = makeShortcode("Checkbox");
const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Header title='Income errors' subtitle='Guide to troubleshooting Income errors' mdxType="Header" />
    <h4 {...{
      "id": "income_verification_document_not_found"
    }}><strong parentName="h4">{`INCOME_VERIFICATION_DOCUMENT_NOT_FOUND`}</strong></h4>
    <ErrorReference type='INCOME_VERIFICATION_ERROR' error='INCOME_VERIFICATION_DOCUMENT_NOT_FOUND' subtitle="The requested income verification document was not found." client server mdxType="ErrorReference">
      <h5 {...{
        "id": "common-causes"
      }}>{`Common causes`}</h5>
      <ul>
        <li parentName="ul">{`The document URL is incorrect (for example, it may contain a typo) or has expired.`}</li>
        <li parentName="ul">{`The document URL has already been accessed. Document URLs can only be used once.`}</li>
      </ul>
      <h5 {...{
        "id": "troubleshooting-steps"
      }}>{`Troubleshooting steps`}</h5>
      <Checkbox checklistId='INCOME_VERIFICATION_DOCUMENT_NOT_FOUND-1' mdxType="Checkbox">
        <p>{`Check that the document URL is entered correctly.`}</p>
      </Checkbox>
      <Checkbox checklistId='INCOME_VERIFICATION_DOCUMENT_NOT_FOUND-2' mdxType="Checkbox">
        <p>{`Make a new call to `}<inlineCode parentName="p">{`/credit/payroll_income/get`}</inlineCode>{` to generate a new document URL.`}</p>
      </Checkbox>
    </ErrorReference>
    <h4 {...{
      "id": "income_verification_failed"
    }}><strong parentName="h4">{`INCOME_VERIFICATION_FAILED`}</strong></h4>
    <ErrorReference type='INCOME_VERIFICATION_ERROR' error='INCOME_VERIFICATION_FAILED' subtitle="The income verification you are trying to retrieve could not be completed. Please try creating a new income verification" client server mdxType="ErrorReference">
      <h5 {...{
        "id": "common-causes-1"
      }}>{`Common causes`}</h5>
      <ul>
        <li parentName="ul">{`The processing of the verification failed to complete successfully.`}</li>
      </ul>
      <h5 {...{
        "id": "troubleshooting-steps-1"
      }}>{`Troubleshooting steps`}</h5>
      <Checkbox checklistId='INCOME_VERIFICATION_FAILED-1' mdxType="Checkbox">
        <p>{`Have the user retry the verification.`}</p>
      </Checkbox>
      <Checkbox checklistId='INCOME_VERIFICATION_FAILED-2' mdxType="Checkbox">
        <p>{`If the problem persists, `}<a parentName="p" {...{
            "href": "https://dashboard.plaid.com/support"
          }}>{`contact Plaid support`}</a>{`.`}</p>
      </Checkbox>
    </ErrorReference>
    <h4 {...{
      "id": "income_verification_not_found"
    }}><strong parentName="h4">{`INCOME_VERIFICATION_NOT_FOUND`}</strong></h4>
    <ErrorReference type='INCOME_VERIFICATION_ERROR' error='INCOME_VERIFICATION_NOT_FOUND' subtitle="The requested income verification was not found." client server mdxType="ErrorReference">
      <h5 {...{
        "id": "common-causes-2"
      }}>{`Common causes`}</h5>
      <ul>
        <li parentName="ul">{`The Link flow has not been completed with `}<inlineCode parentName="li">{`income_verification`}</inlineCode>{` enabled; either the user has not yet completed the Link flow, or the link token was not initialized with the `}<inlineCode parentName="li">{`income_verification`}</inlineCode>{` product.`}</li>
      </ul>
      <h5 {...{
        "id": "troubleshooting-steps-2"
      }}>{`Troubleshooting steps`}</h5>
      <Checkbox checklistId='INCOME_VERIFICATION_NOT_FOUND-1' mdxType="Checkbox">
        <p>{`Make sure to initialize Link with `}<inlineCode parentName="p">{`income_verification`}</inlineCode>{` in the product array.`}</p>
      </Checkbox>
      <Checkbox checklistId='INCOME_VERIFICATION_NOT_FOUND-2' mdxType="Checkbox">
        <p>{`Listen for the `}<a parentName="p" {...{
            "href": "/docs/api/products/income/#user_income_verification"
          }}><inlineCode parentName="a">{`INCOME: USER_INCOME_VERIFICATION`}</inlineCode></a>{` webhook with a corresponding `}<inlineCode parentName="p">{`item_id`}</inlineCode>{`, which will fire once verification is complete. Legacy integrations receive `}<inlineCode parentName="p">{`INCOME_VERIFICATION`}</inlineCode>{` instead.`}</p>
      </Checkbox>
    </ErrorReference>
    <h4 {...{
      "id": "income_verification_upload_error"
    }}><strong parentName="h4">{`INCOME_VERIFICATION_UPLOAD_ERROR`}</strong></h4>
    <ErrorReference type='INCOME_VERIFICATION_ERROR' error='INCOME_VERIFICATION_UPLOAD_ERROR' subtitle="There was an error uploading income verification documents." client server mdxType="ErrorReference">
      <h5 {...{
        "id": "common-causes-3"
      }}>{`Common causes`}</h5>
      <ul>
        <li parentName="ul">{`The end user's Internet connection may have been interrupted during the upload attempt.`}</li>
      </ul>
      <h5 {...{
        "id": "troubleshooting-steps-3"
      }}>{`Troubleshooting steps`}</h5>
      <Checkbox checklistId='INCOME_VERIFICATION_UPLOAD_ERROR-1' mdxType="Checkbox">
        <p>{`Plaid will prompt the end user to re-try uploading their documents.`}</p>
      </Checkbox>
    </ErrorReference>
    <h4 {...{
      "id": "product_not_ready"
    }}><strong parentName="h4">{`PRODUCT_NOT_READY`}</strong></h4>
    <ErrorReference type='INCOME_VERIFICATION_ERROR' error='PRODUCT_NOT_READY' subtitle="The Income product has not completed processing." server mdxType="ErrorReference">
      <h5 {...{
        "id": "common-causes-4"
      }}>{`Common causes`}</h5>
      <ul>
        <li parentName="ul">{`Parsing of the uploaded pay stubs has not yet completed.`}</li>
      </ul>
      <h5 {...{
        "id": "troubleshooting-steps-4"
      }}>{`Troubleshooting steps`}</h5>
      <Checkbox checklistId='PRODUCT_NOT_READY-1' mdxType="Checkbox">
        <p>{`Listen for the `}<a parentName="p" {...{
            "href": "/docs/api/products/income/#user_income_verification"
          }}><inlineCode parentName="a">{`INCOME: USER_INCOME_VERIFICATION`}</inlineCode></a>{` webhook with a corresponding `}<inlineCode parentName="p">{`item_id`}</inlineCode>{`, which will fire once verification is complete. Legacy integrations receive `}<inlineCode parentName="p">{`INCOME_VERIFICATION`}</inlineCode>{` instead.`}</p>
      </Checkbox>
    </ErrorReference>
    <h4 {...{
      "id": "employment_not_found"
    }}><strong parentName="h4">{`EMPLOYMENT_NOT_FOUND`}</strong></h4>
    <ErrorReference type='INCOME_VERIFICATION_ERROR' error='EMPLOYMENT_NOT_FOUND' subtitle="The requested employment was not found." client server mdxType="ErrorReference">
      <h5 {...{
        "id": "common-causes-5"
      }}>{`Common causes`}</h5>
      <ul>
        <li parentName="ul">{`The Link flow has not been completed with `}<inlineCode parentName="li">{`employment`}</inlineCode>{` enabled; either the user has not yet completed the Link flow, or the link token was not initialized with the `}<inlineCode parentName="li">{`employment`}</inlineCode>{` product.`}</li>
      </ul>
      <h5 {...{
        "id": "troubleshooting-steps-5"
      }}>{`Troubleshooting steps`}</h5>
      <Checkbox checklistId='EMPLOYMENT_NOT_FOUND-1' mdxType="Checkbox">
        <p>{`Make sure to initialize Link with `}<inlineCode parentName="p">{`employment`}</inlineCode>{` in the product array.`}</p>
      </Checkbox>
      <Checkbox checklistId='EMPLOYMENT_NOT_FOUND-2' mdxType="Checkbox">
        <p>{`Listen for the `}<a parentName="p" {...{
            "href": "/docs/api/products/income/#user_income_verification"
          }}><inlineCode parentName="a">{`INCOME: USER_INCOME_VERIFICATION`}</inlineCode></a>{` webhook with a corresponding `}<inlineCode parentName="p">{`item_id`}</inlineCode>{`, which will fire once verification is complete. Legacy integrations receive `}<inlineCode parentName="p">{`INCOME_VERIFICATION`}</inlineCode>{` instead.`}</p>
      </Checkbox>
    </ErrorReference>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      {
        id: "income_verification_document_not_found",
        level: 4,
        title: "INCOME_VERIFICATION_DOCUMENT_NOT_FOUND",
      },
{
        id: "income_verification_failed",
        level: 4,
        title: "INCOME_VERIFICATION_FAILED",
      },
{
        id: "income_verification_not_found",
        level: 4,
        title: "INCOME_VERIFICATION_NOT_FOUND",
      },
{
        id: "income_verification_upload_error",
        level: 4,
        title: "INCOME_VERIFICATION_UPLOAD_ERROR",
      },
{
        id: "product_not_ready",
        level: 4,
        title: "PRODUCT_NOT_READY",
      },
{
        id: "employment_not_found",
        level: 4,
        title: "EMPLOYMENT_NOT_FOUND",
      }
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
